import React from 'react';

const ConfirmationModal = ({ 
  isOpen, 
  title = "Are you absolutely sure?", 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = "Yes, Mark as Paid", 
  cancelText = "No, cancel", 
  isDestructive = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-gray-900 bg-opacity-70 backdrop-blur-sm transition-opacity">
      <div className="bg-white rounded-[24px] w-[90%] max-w-sm overflow-hidden shadow-2xl flex flex-col transform transition-all items-center p-8 text-center" style={{ animation: "fadeIn 0.2s ease-out" }}>
        
        {/* Icon */}
        <div className={`w-[72px] h-[72px] rounded-full flex items-center justify-center mb-5 ${isDestructive ? 'bg-red-50 text-red-500' : 'bg-primary-50 text-primary-600'}`}>
          {isDestructive ? (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          ) : (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          )}
        </div>
        
        <h3 className="text-2xl font-extrabold text-gray-900 mb-3 tracking-tight leading-tight">{title}</h3>
        <p className="text-[14px] font-medium text-gray-500 mb-8 px-2">{message}</p>
        
        <div className="flex gap-3 w-full">
          <button
            onClick={onCancel}
            className="flex-1 py-3.5 bg-gray-100 hover:bg-gray-200 active:scale-95 text-gray-700 rounded-xl font-bold transition-all text-[13px] tracking-wide"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-[1.2] py-3.5 active:scale-95 text-white rounded-xl font-bold transition-all text-[13px] tracking-wide shadow-md ${
              isDestructive ? 'bg-red-500 hover:bg-red-600 shadow-red-200' : 'bg-primary-600 hover:bg-primary-700 shadow-primary-200'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ConfirmationModal;
